/**
 * @file: usePlaySoundEffect.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Audio } from 'expo-av';
import { AVPlaybackSource } from 'expo-av/build/AV.types';
import { useCallback, useEffect, useRef } from 'react';
import { Platform } from 'react-native';

export const usePlaySoundEffect = (source: AVPlaybackSource, volume = 1) => {
  const soundRef = useRef<Audio.Sound>();
  const playSound = useCallback(async () => {
    try {
      // Fix play() failed because the user didn‘t interact with the document first,
      // Autoplay policy in Chrome,see:
      // https://developer.chrome.com/blog/autoplay/#web-audio
      if (Platform.OS === 'web') return;
      if (soundRef.current == null) {
        const { sound } = await Audio.Sound.createAsync(source, {
          volume,
        }).then();
        soundRef.current = sound;
      }
      void soundRef.current.replayAsync();
    } catch (e) {
      console.error('error load sound file: ', e);
    }
  }, [source, volume]);

  useEffect(() => {
    return () => {
      void soundRef.current?.unloadAsync();
      soundRef.current = undefined;
    };
  }, [playSound]);

  return useCallback(async () => {
    await playSound();
  }, [playSound]);
};
